import React, { useState } from 'react';
import CurrencyFormat from 'react-currency-format';
import moment from 'moment';
import { formatCustomDate } from '../../helpers/formatCustomDate';
import SalesOrderAddressModal from '../sales_order/SalesOrderAddressModal';

const PackageDetailsContent = ({ packageList, packageDetails, setAddressModal }) => {
  const manageSalesStatus = (status, id) => {
    let defaultClass = 'status_color1 text-white';

    switch (id) {
      case 1:
        defaultClass = 'text-light status_color2';
        break;
      case 2:
        defaultClass = 'text-light status_color3';
        break;
      case 3:
        defaultClass = 'text-dark status_color4';
        break;
      case 4:
        defaultClass = 'text-light status_color5';
        break;
      case 5:
        defaultClass = 'text-light status_color6';
        break;
      case 6:
        defaultClass = 'text-light status_color1';
        break;
      case 7:
        defaultClass = 'text-light status_color8';
        break;

      default:
        break;
    }

    return <span className={`px-4 py-2.5 rounded font-semibold ${defaultClass}`}>{status}</span>;
  };

  //  calculate  sub total
  const calculateSubTotal = list => {
    let resuilt = 0;

    list?.forEach(element => {
      resuilt += element.item_sales_quantity * element.item_sales_rate;
    });
    return resuilt?.toFixed(2);
  };

  //  calculate base quantity with discount, adjustment and shipping
  const calculateBaseTotal = list => {
    let result = 0;
    list?.forEach(element => {
      result += element.item_sales_quantity * element.item_sales_rate;
    });

    const discountValue = packageDetails?.discount_amount;
    const discountType = packageDetails?.discount_type_id;
    const ShippingAmount = packageDetails?.shipping_amount;
    const adjustmentAmount = packageDetails?.adjustment_amount;

    if (ShippingAmount) {
      result += ShippingAmount;
    }
    if (adjustmentAmount) {
      result += adjustmentAmount;
    }

    if (discountValue && (discountType === 1 || discountType === 0)) {
      result = result - discountValue;
    }

    if (discountValue && discountType === 2) {
      let discount = (discountValue / 100) * result;
      result = Number(result) - Number(discount);
    }
    return result?.toFixed(2);
  };

  return (
    <div className="bg-white p-8 w-full shadow-lg">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-8">
        <div>
          <img
            src="https://inventory.zoho.com/ZFInvoiceLogo.zbfs?logo_id=70d87924b8a12a43636280e0f950de09"
            alt="Worldbay Logo"
            className="w-20"
          />
          <p className="text-gray-600">Worldbay Technologies Ltd</p>
          <p className="text-gray-600">TIN *********</p>
          <p className="text-gray-600">VAT ********* </p>
          <p className="text-gray-600">Plot 4b Chief Augustine Anozie Street</p>
          <p className="text-gray-600">Lekki Phase 1, Lagos, Nigeria</p>
        </div>
        <div className="text-right">
          <h2 className="text-3xl font-bold">PACKAGE</h2>
          <p className="text-gray-600">Package# {packageDetails?.package_slip_number} </p>

          <h2 className="text-3xl mt-4 font-bold">
            {' '}
            {manageSalesStatus(packageDetails?.sales_order_status_name, packageDetails?.sales_order_status_id)}{' '}
          </h2>
        </div>
      </div>

      {/* Details Section */}
      <div className="grid grid-cols-2 gap-4 mb-8">
        <div>
          <span className="font-semibold">Order Date: </span>{' '}
          <span className="text-gray-600"> {packageDetails?.sales_order_date_string} </span>
          <br />
          <span className="font-semibold">Package Date: </span>{' '}
          <span className="text-gray-600">{moment(packageDetails?.package_date).format('DD-MM-YYYY')} </span>
          <br />
          <span className="font-semibold">Sales Order#: </span>
          <span className="text-gray-600">{packageDetails?.sales_order_no} </span>
          <br />
          <span className="font-semibold">Sales Ref #: </span>
          <span className="text-gray-600">{packageDetails?.sales_order_ref_no} </span>
        </div>
        {/* <div className="text-right">
          <span className="font-semibold">Total Qty:</span>
          <span className="text-gray-600"> {packageList?.length?.toFixed(2)} </span>
        </div> */}
      </div>

      <div className="grid grid-cols-2 gap-4 mb-2">
        <div>
          <p className="font-semibold">Shipping Address</p>
          <p className="text-gray-600">{packageDetails?.order_recipient_full_shipping_address}</p>
          <button
            type="button"
            className='class="btn bg-blue-500 text-white  font-bold py-2 px-4 ml-2 rounded"'
            onClick={() => setAddressModal(true)}
          >
            Edit{' '}
          </button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-2">
        {/* card */}
        <div className="w-full bg-white shadow-md rounded-2xl p-2 border border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Customer Information</h2>

          <ul className="divide-y divide-gray-100">
            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                Full Name: <span className="text-gray-900 font-bold ">{packageDetails?.customer_full_name} </span>{' '}
              </span>
            </li>
            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                Email: <span className="text-gray-900 font-bold ">{packageDetails?.customer_email_address} </span>{' '}
              </span>
            </li>
            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                Order Type: <span className="text-gray-900 font-bold">{packageDetails?.gift_status_name} </span>{' '}
              </span>
            </li>
            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                Recipient Name: <span className="text-gray-900 font-bold">{packageDetails?.order_recipient_name} </span>{' '}
              </span>
            </li>
            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                Recipient Mobile: <span className="text-gray-900 font-bold">{packageDetails?.order_recipient_phone_number} </span>{' '}
              </span>
            </li>
            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                Recipient Email: <span className="text-gray-900 font-bold">{packageDetails?.order_recipient_email} </span>{' '}
              </span>
            </li>
          </ul>
        </div>
        {/* card end */}
        {/* card */}
        <div className="w-full bg-white shadow-md rounded-2xl p-2 border border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Package Information</h2>

          <ul className="divide-y divide-gray-100">
            <li className="py-3 flex justify-between">
              <span className="text-gray-600 font-medium">
                SLip No.: <span className="text-gray-900 font-bold">{packageDetails?.package_slip_number} </span>{' '}
              </span>
            </li>

            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                Warehouse: <span className="text-gray-900 font-bold">{packageDetails?.warehouse_name} </span>{' '}
              </span>
            </li>
            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                SO No: <span className="text-gray-900 font-bold">{packageDetails?.sales_order_no} </span>{' '}
              </span>
            </li>
            <li className="py-1 flex justify-between">
              <span className="text-gray-600 font-medium">
                Pick Up Date: <span className="text-gray-900 font-bold">{packageDetails?.pickup_date_string} </span>{' '}
              </span>
            </li>
          </ul>
        </div>

        {/* card end */}
      </div>

      {/* Table Section */}
      <table className="w-full bg-white border">
        <thead>
          <tr>
            <th className="py-2 px-4 border-b">#</th>
            <th className="py-2 px-4 border-b">Item & Description</th>
            <th className="py-2 px-4 border-b">Qty</th>
            <th className="py-2 px-4 border-b">Rate</th>
            <th className="py-2 px-4 border-b">Sub Total</th>
          </tr>
        </thead>
        <tbody>
          {packageList?.map((pkg, i) => {
            return (
              <>
                <tr>
                  <td className="py-2 px-4 border-b">{i + 1} </td>
                  <td className="py-2 px-4 border-b">{pkg?.item_name} </td>
                  <td className="py-2 px-4 border-b">
                    <CurrencyFormat
                      value={parseFloat(pkg?.item_sales_quantity)?.toFixed(2)}
                      displayType={'text'}
                      thousandSeparator={true}
                    />
                  </td>
                  <td className="py-2 px-4 border-b">
                    <CurrencyFormat value={parseFloat(pkg?.item_sales_rate)?.toFixed(2)} displayType={'text'} thousandSeparator={true} />
                  </td>

                  <td className="py-2 px-4 border-b">
                    <CurrencyFormat value={parseFloat(pkg?.total_amount)?.toFixed(2)} displayType={'text'} thousandSeparator={true} />
                  </td>

                  {/* <td className="py-2 px-4 border-b">
                <CurrencyFormat value={parseFloat((pkg?.item_sales_rate * pkg.item_sales_quantity ) - pkg?.discount_amount )?.toFixed(2)}
                       displayType={'text'} thousandSeparator={true} />
                 </td> */}
                </tr>
              </>
            );
          })}
        </tbody>
      </table>

      {/* Footer Section */}
      <div className="flex justify-between items-center mt-8">
        <p className="text-sm text-gray-500"> Remark: {packageDetails?.package_remark} </p>
        {/* <h3 className="font-semibold">
          Grand Total:  
          <CurrencyFormat value={parseFloat(packageDetails?.Sales_Order_Amount )?.toFixed(2)}
                       displayType={'text'} thousandSeparator={true} />
          </h3> */}
        {/* start */}
        <div className=" px-3 lg:px-4">
          <div className="mt-3  px-3 lg:px-4 border-[1px] border-gray-200 rounded-lg p-3 flex items-center justify-end">
            <div className="">
         
              <div className="flex flex-row">
                <div className="text-sm font-bold mr-2">Discount:</div>{' '}
                <div className="w-[170px] flex-shrink-0">
                  <div className="text-sm">
                    {packageDetails?.discount_type_id === 1 && (
                      <CurrencyFormat
                        value={packageDetails?.discount_amount?.toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'₦'}
                      />
                    )}

                    {packageDetails?.discount_type_id === 2 && (
                      <CurrencyFormat
                        value={packageDetails?.discount_amount?.toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'%'}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="flex flex-row">
                <div className="text-sm font-bold mr-2">Adjustment:</div>
                <div className="w-[170px] flex-shrink-0">
                  <div className="text-sm">
                    <CurrencyFormat
                      value={parseFloat(packageDetails?.adjustment_amount)?.toFixed(2)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'₦'}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-row">
                <div className="text-gray-600 font-bold mr-2">Sub Total:</div>{' '}
                <div className="w-[170px] flex-shrink-0">
                  <div className="text-gray-600 font-bold">
                    <CurrencyFormat
                      value={parseFloat(calculateSubTotal(packageList))?.toFixed(2)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'₦'}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-row ">
                <div className="text-2xl font-bold mr-2">Total:</div>{' '}
                <div className="w-[170px] flex-shrink-0">
                  <div className="text-2xl  font-bold">
                    <CurrencyFormat
                      value={parseFloat(calculateBaseTotal(packageList))?.toFixed(2)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={'₦'}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* start end */}
      </div>
    </div>
  );
};

export default PackageDetailsContent;
